import { default as aboutlv6i1FL0CfMeta } from "/opt/build/repo/pages/about.vue?macro=true";
import { default as indexdOGBLSe4kzMeta } from "/opt/build/repo/pages/categoria/[slug]/record-[id]/index.vue?macro=true";
import { default as _91slug_93tw36rUgoURMeta } from "/opt/build/repo/pages/categoria/[slug].vue?macro=true";
import { default as indexu1AdvMv6O3Meta } from "/opt/build/repo/pages/cause-sociali/[slug]/record-[id]/index.vue?macro=true";
import { default as _91slug_93oLakbZ9r9mMeta } from "/opt/build/repo/pages/cause-sociali/[slug].vue?macro=true";
import { default as index4JZJ3CjBPTMeta } from "/opt/build/repo/pages/cerca/record-[id]/index.vue?macro=true";
import { default as cercay8Odut146CMeta } from "/opt/build/repo/pages/cerca.vue?macro=true";
import { default as come_45funzionaiV59A49MDxMeta } from "/opt/build/repo/pages/come-funziona.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as partecipantiIXiiYVPTTOMeta } from "/opt/build/repo/pages/partecipanti.vue?macro=true";
import { default as indexXtaeFus3bEMeta } from "/opt/build/repo/pages/partnership-aziendale/index.vue?macro=true";
import { default as index0mmc4Wrwy5Meta } from "/opt/build/repo/pages/per-aziende/record-[id]/index.vue?macro=true";
import { default as per_45aziendeviFsYiXJKcMeta } from "/opt/build/repo/pages/per-aziende.vue?macro=true";
import { default as indexMyRu96l8bWMeta } from "/opt/build/repo/pages/regalo-solidale/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutlv6i1FL0CfMeta || {},
    component: () => import("/opt/build/repo/pages/about.vue")
  },
  {
    name: "categoria-slug",
    path: "/categoria/:slug()",
    component: () => import("/opt/build/repo/pages/categoria/[slug].vue"),
    children: [
  {
    name: "categoria-slug-record-id",
    path: "record-:id()",
    component: () => import("/opt/build/repo/pages/categoria/[slug]/record-[id]/index.vue")
  }
]
  },
  {
    name: "cause-sociali-slug",
    path: "/cause-sociali/:slug()",
    component: () => import("/opt/build/repo/pages/cause-sociali/[slug].vue"),
    children: [
  {
    name: "cause-sociali-slug-record-id",
    path: "record-:id()",
    component: () => import("/opt/build/repo/pages/cause-sociali/[slug]/record-[id]/index.vue")
  }
]
  },
  {
    name: "cerca",
    path: "/cerca",
    meta: cercay8Odut146CMeta || {},
    component: () => import("/opt/build/repo/pages/cerca.vue"),
    children: [
  {
    name: "cerca-record-id",
    path: "record-:id()",
    component: () => import("/opt/build/repo/pages/cerca/record-[id]/index.vue")
  }
]
  },
  {
    name: "come-funziona",
    path: "/come-funziona",
    meta: come_45funzionaiV59A49MDxMeta || {},
    component: () => import("/opt/build/repo/pages/come-funziona.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "partecipanti",
    path: "/partecipanti",
    component: () => import("/opt/build/repo/pages/partecipanti.vue")
  },
  {
    name: "partnership-aziendale",
    path: "/partnership-aziendale",
    component: () => import("/opt/build/repo/pages/partnership-aziendale/index.vue")
  },
  {
    name: "per-aziende",
    path: "/per-aziende",
    component: () => import("/opt/build/repo/pages/per-aziende.vue"),
    children: [
  {
    name: "per-aziende-record-id",
    path: "record-:id()",
    component: () => import("/opt/build/repo/pages/per-aziende/record-[id]/index.vue")
  }
]
  },
  {
    name: "regalo-solidale",
    path: "/regalo-solidale",
    component: () => import("/opt/build/repo/pages/regalo-solidale/index.vue")
  }
]